<template>

	<dialog-slot
			title="Send selected invoices"
			@updateClose="onCloseDialog"
			@updateSave="onSave"
			apply-text="Save"
			width="1340px"
			is-footer-flex-end
	>
		<v-data-table
				:headers="getHeader"
				:items="selectedInvoices"
				class="sendInvoicesw"
				hide-default-footer
				hide-default-header
				hide-default-body
				disable-pagination
				fixed-header
		>
			<template v-slot:header="{ props: { headers } }">
				<thead class="v-data-table-header">
				<tr>
					<th
							v-for="(item, index) in headers"
							:key="index"
							class="text-start sortable position-relative"
							:id="'container-'+item.value"
					>
						<span class="headText wh_w">{{ item.text }}</span>
					</th>
				</tr>
				<tr class="fxiSticky">
					<th></th>
					<th></th>
					<th></th>
					<th></th>

					<th>
						<field
								margin="0 auto"
								overflow="hidden"
								width="24px"
								padding="0"
								height="24"
								:switch-value="send_sms"
								@updateSwitch="onCheckbox($event, 'send_sms')"
								is-dense
								is-checkbox
								is-off-style
						></field>
					</th>

					<th align="center">
						<field
								margin="0 auto"
								overflow="hidden"
								width="24px"
								padding="0"
								height="24"
								:switch-value="send_invoices"
								@updateSwitch="onCheckbox($event, 'send_invoices')"
								is-dense
								is-checkbox
								is-off-style
						></field>
					</th>
					<th>
						<field
								margin="0 auto"
								overflow="hidden"
								width="24px"
								padding="0"
								height="24"
								:switch-value="send_dispatch_report"
								@updateSwitch="onCheckbox($event, 'send_dispatch_report')"
								is-dense
								is-checkbox
								is-off-style
						></field>
					</th>
					<th>
						<field
								margin="0 auto"
								overflow="hidden"
								width="24px"
								padding="0"
								height="24"
								:switch-value="send_safety_report"
								@updateSwitch="onCheckbox($event, 'send_safety_report')"
								is-dense
								is-checkbox
								is-off-style
						></field>
					</th>
					<th>
						<field
								margin="0 auto"
								overflow="hidden"
								width="24px"
								padding="0"
								height="24"
								:switch-value="send_billing_report"
								@updateSwitch="onCheckbox($event, 'send_billing_report')"
								is-dense
								is-checkbox
								is-off-style
						></field>
					</th>
				</tr>
				</thead>
			</template>
			<template v-slot:body="{ items }">
				<tbody>
				<template v-for="(item, idx) in items">
					<table-tr
							:item="item"
							:key="item.id"
							:idx="idx"
							:valid="$v"
							:isSms="send_sms"
					></table-tr>
				</template>
				</tbody>
			</template>
		</v-data-table>
		<template v-slot:subTitleFooter>
			<field
					margin="0"
					width="200px"
					label="Template"
					placeholder="Select template"
					@updateSelect="onAutocomplete"
					:autocompleteValue="template"
					:items="[{ id: 1, value: 'Standard' }, { id: 2, value: 'Remind' }, { id: 3, value: 'Information' }, { id: 4, value: 'Safety #' }, { id: 5, value: 'ELD migration' }]"
					:isClearable="false"
					is-select
			></field>
		</template>
	</dialog-slot>
</template>

<script>
import { mapActions } from "vuex";
// components
import TableTr from "@/components/Accounting/CustomerInvoices/SendInvoices/TableTr/TableTr";
import sendInvoicesHeaders from "@/components/Accounting/CustomerInvoices/SendInvoices/sendInvoicesHeaders";
// shared
// validate
import { email, required } from "vuelidate/lib/validators";
import { validationMixin } from "vuelidate";
import DialogSlot from "@/shared/DialogSlot/DialogSlot.vue";

export default {
	name: "SendInvoices",
	mixins: [ validationMixin ],
	components: { DialogSlot, TableTr },
	computed: {
		getHeader() {
			return sendInvoicesHeaders;
		}
	},
	props: {
		selectedInvoices: Array
	},
	data: () => ({
		send_invoices: true,
		send_billing_report: false,
		send_dispatch_report: false,
		send_safety_report: false,
		send_sms: false,
		template: 1
	}),
	validations: {
		selectedInvoices: {
			$each: {
				email: { required, email },
			},
		},
	},
	methods: {
		...mapActions([ 'onSendInvoicesReports', 'setAlert', 'actionPreloader' ]),
		onAutocomplete({ value }) {
			this.template = value?.id ?? value;
		},
		onCheckbox({ value }, key) {
			this[key] = value;
		},
		onInput({ value, idx }) {
			this.selectedInvoices[idx].email = value;
		},
		onLink(value) {
			this.$emit("updateLink", value);
		},
		onCloseDialog(value) {
			this.$emit("updateSendInvoicesClose", value);
		},
		async onSave() {
			this.$v.$touch();
			if (!this.$v.$error) {
				const invoices = this.selectedInvoices.map(({ invoice_id, email }) => ({ invoice_id, email }));
				const values = {
					invoices,
					send_invoices: this.send_invoices,
					send_billing_report: this.send_billing_report,
					send_sms: this.send_sms,
					send_dispatch_report: this.send_dispatch_report,
					send_safety_report: this.send_safety_report,
					template: this.template
				};

				this.actionPreloader(true);
				const { status } = await this.onSendInvoicesReports(values);
				if (status) {
					this.setAlert({ type: "success", message: "Invoices sent successfully" });
					this.onCloseDialog(1);
				} else {
					this.setAlert({ type: "error", message: "Invoices sent error" });
				}
				this.actionPreloader(false);
			} else {
				this.setAlert({ type: "error", message: "Email field is required" });
			}
		}
	}
};
</script>

<style scoped lang="scss">
@import "SendInvoices";
#app {
	.sendInvoicesw {
		thead {
			th {
				> .headText {
					min-height: 48px;
				}
			}
		}
		.fxiSticky  {
			td {
				position: static;
			}

		}
	}

	.v-data-table--fixed-header > .v-data-table__wrapper > table > thead > tr > th {
		position: static;

		> .headText {
			min-height: 48px;
			display: flex;
			align-items: center;
			justify-content: center;
			padding: 0;
		}
		> div {
			min-height: 46px;
			display: flex;
			align-items: center;
			justify-content: center;
			padding: 0;
			.v-application--is-ltr .v-input--selection-controls__input {
				margin-right: 0;
			}
		}
	}

}

</style>
